import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import UnAuthenticatedRoutes from "./UnAuthenticatedRoutes";
import AuthenticatedRoutes from "./AuthenticatedRoutes";
import { ConfigProvider } from "../context/ConfigContext";
import { ClientAccessProvider } from "../context/ClientAccessContext";
import { PanelContextProvider } from "../context/PanelContext";
import { DocumentsProvider } from "../context/DocumentContext";
import { TranslationProvider } from "../context/TranslationContext";
import { ChatProvider } from "../context/ChatContext";
import { EventTrackingProvider } from "../context/EventTrackingContext";

const Router: React.FunctionComponent = () => {
	const isAuthenticated = useIsAuthenticated();

	return isAuthenticated ? (
		<PanelContextProvider>
			<ClientAccessProvider>
				<ConfigProvider>
					<EventTrackingProvider>
						<DocumentsProvider>
							<TranslationProvider>
								<ChatProvider>
									<AuthenticatedRoutes />
								</ChatProvider>
							</TranslationProvider>
						</DocumentsProvider>
					</EventTrackingProvider>
				</ConfigProvider>
			</ClientAccessProvider>
		</PanelContextProvider>
	) : (
		<UnAuthenticatedRoutes />
	);
};

export default Router;
